<template>
  <div>
    <zj-layout-container>
      <zj-layout-header style="paddingtop: 40px">
        <el-date-picker
          v-model="chooseDate"
          type="month"
          format="yyyy-MM"
          :clearable="false"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-button size="medium" style="margin-left: 30px" @click="search"
          >查询</el-button
        >
      </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div class="echart_1">
            <div>
              月客流走势同比
              <LineEchartsTicket
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="usePerData"
              ></LineEchartsTicket>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import { getFlowTrend } from "@/api/src/bigData";
import moment from "moment";
export default {
  action: "PassengerFlowMonth",
  controller: "UI",
  name: "PassengerFlowMonth",
  data() {
    return {
      chooseDate: new Date(),
      usePerData: {},
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
      this.usePerData = {
        xData: [],
        yData: [
          {
            name: "",
            data: [],
          },
        ],
      };
      let date = this.getFormatTime(this.chooseDate);
      let params = {
        polityType: 3,
        timeType: "day",
        timeValue: this.getMonthEnd(date),
        district: this.CNF("app.districtCode"),
        districtCode: this.CNF("app.districtCode"),
        startTime: date + "-01",
        endTime: date + "-" + this.getMonthEnd(date),
      };
      getFlowTrend(params).then((res) => {
        if (res.data) {
          let dataList = res.data.dataList || {};
          var XData = [];
          for (let key in dataList) {
            XData = [];
            var yDataObj = {
              name: key,
              data: [],
            };
            dataList[key].map((item) => {
              const { dataTime, count } = item;
              XData.push(moment(dataTime).format("DD"));
              yDataObj.data.push(count);
            });
            this.usePerData.yData.push(yDataObj);
          }
          this.usePerData.xData = XData;
          console.log("月客流走势", this.usePerData);
        }
      });
    },

    getMonthEnd(date) {
      let dateArr = date.split("-"),
        month = Number.parseInt(dateArr[1]),
        year = dateArr[0];
      switch (month) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
          return 31;
        case 4:
        case 6:
        case 9:
        case 11:
          return 30;
        case 2:
          return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0
            ? 29
            : 28;
        default:
          return 0;
      }
    },

    getFormatTime(nS) {
      var date = new Date(nS); //获取一个时间对象
      let y = date.getFullYear(); // 获取完整的年份(4位,1970)
      let m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1; // 获取月份(0-11,0代表1月,用的时候记得加上1)
      return y + "-" + m;
    },
  },
};
</script>

<style scoped lang="scss">
.datelabel {
  border-right: 3px solid #2bc5ff;
  padding: 0 1rem;
}
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart_1,
.echart_2 {
  width: 100%;
  height: 48%;
}
.echart_1 {
  margin-bottom: 15px;
}
.echart_2 {
  margin-top: 15px;
}
.echart_1 > div,
.echart_2 > div {
  float: left;
  width: 50%;
  height: 100%;
  color: #2bc5ff;
  font-weight: bold;
}
</style>